import { useState } from 'react';
import styles from './ActivitiesPage.module.css';
import Dropdown from '../../components/Dropdown/Dropdown';

import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import CopyRight from '../../components/CopyRight/CopyRight';
import ActivitiesPagesCard from '../../components/ActivitiesPagesCard/ActivitiesPagesCard';
import SearchBar from '../../components/SearchBar/SearchBar';
import { NavLink } from 'react-router';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import photoImage from './../../assets/images/Dailyactivityphoto.png';
import announcementsImage from './../../assets/images/announcements.png';
import musicPlayImage from './../../assets/images/musicPlay.png';
import QuickActionCard from '../../components/QuickActionCard/QuickActionCard';

const ActivitiesPage = () => {
  const [filters, setFilters] = useState({});
  const dispatch = useDispatch();
  const [ActivitiesPages, setActivitiesPages] = useState([
    {
      id: 1,
      image:
        'https://img.freepik.com/free-photo/front-view-kids-reading-book_23-2150877935.jpg',
      description:
        'Your Kids are playing in the ground. And This activity is led by PT sir and Class teacher Darshan. The kids played approximately for an hour and sanitized',
      tagged: ['Staff 1', 'Staff 2'],
      time: '12:00 PM',
      date: '3rd June 2025',
    },
    {
      id: 2,
      image:
        'https://img.freepik.com/free-photo/front-view-kids-reading-book_23-2150877935.jpg',
      description:
        'Your Kids are playing in the ground. And This activity is led by PT sir and Class teacher Darshan. The kids played approximately for an hour and sanitized',
      tagged: ['Staff 1', 'Staff 2', 'Staff 3'],
      time: '1:30 PM',
      date: '3rd June 2025',
    },
    {
      id: 2,
      image:
        'https://img.freepik.com/free-photo/front-view-kids-reading-book_23-2150877935.jpg',
      description:
        'Your Kids are playing in the ground. And This activity is led by PT sir and Class teacher Darshan. The kids played approximately for an hour and sanitized',
      tagged: ['Staff 1', 'Staff 2', 'Staff 3'],
      time: '1:30 PM',
      date: '3rd June 2025',
    },
    {
      id: 2,
      image:
        'https://img.freepik.com/free-photo/front-view-kids-reading-book_23-2150877935.jpg',
      description:
        'Your Kids are playing in the ground. And This activity is led by PT sir and Class teacher Darshan. The kids played approximately for an hour and sanitized',
      tagged: ['Staff 1', 'Staff 2', 'Staff 3'],
      time: '1:30 PM',
      date: '3rd June 2025',
    },
  ]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    console.log('Filter Changed:', { [key]: value });
  };

  const handleRemoveTagged = (id, name) => {
    setActivitiesPages((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              tagged: item.tagged.filter((t) => t !== name),
            }
          : item
      )
    );
  };

  const handleActionSelect = (action, id) => {
    console.log(`Action '${action}' on ActivitiesPage ID ${id}`);
    // You can dispatch modal or deletion logic here
  };

  const quickActivityActions = [
    {
      label: 'Photos',
      icon: (
        <img src={photoImage} alt={'PhotoImage'} style={{ width: '28px' }} />
      ),
      onClick: () => {
        dispatch(openModal('postActivity'));
      },
    },
    {
      label: 'Announcements',
      icon: (
        <img
          src={announcementsImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Videos',
      icon: (
        <img
          src={musicPlayImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Photos',
      icon: (
        <img src={photoImage} alt={'PhotoImage'} style={{ width: '28px' }} />
      ),
    },
    {
      label: 'Announcements',
      icon: (
        <img
          src={announcementsImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Videos',
      icon: (
        <img
          src={musicPlayImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Photos',
      icon: (
        <img src={photoImage} alt={'PhotoImage'} style={{ width: '28px' }} />
      ),
    },
    {
      label: 'Announcements',
      icon: (
        <img
          src={announcementsImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Videos',
      icon: (
        <img
          src={musicPlayImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Photos',
      icon: (
        <img src={photoImage} alt={'PhotoImage'} style={{ width: '28px' }} />
      ),
    },
    {
      label: 'Announcements',
      icon: (
        <img
          src={announcementsImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Videos',
      icon: (
        <img
          src={musicPlayImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Photos',
      icon: (
        <img src={photoImage} alt={'PhotoImage'} style={{ width: '28px' }} />
      ),
    },
    {
      label: 'Announcements',
      icon: (
        <img
          src={announcementsImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Videos',
      icon: (
        <img
          src={musicPlayImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Photos',
      icon: (
        <img src={photoImage} alt={'PhotoImage'} style={{ width: '28px' }} />
      ),
    },
    {
      label: 'Announcements',
      icon: (
        <img
          src={announcementsImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
    {
      label: 'Videos',
      icon: (
        <img
          src={musicPlayImage}
          alt={'PhotoImage'}
          style={{ width: '28px' }}
        />
      ),
    },
  ];

  return (
    <>
      <div className={styles.ActivitiesPage}>
        <div className={styles.statsSectionContainer}>
          <h4 className={styles.sectionTitle}>Posts Summary</h4>
          <div className={styles.cardsWrapper}>
            <ResultAndCount
              label="In Progress"
              count={0}
              bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
              textColor="Success_Color"
            />
            <ResultAndCount
              label="Upload failed"
              count={0}
              bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
              textColor="Error_Color"
            />
            <ResultAndCount
              label="Under Feedback"
              count={0}
              bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
              textColor="Text_Color"
            />
            <ResultAndCount
              label="Drafts"
              count={0}
              bgColor="rgba(from var(--Primary_Color) r g b / 0.4)"
              textColor="Primary_Color"
            />
          </div>
        </div>
        <div className={styles.quickActivityContainer}>
          <h4 className={styles.sectionTitle}>Post an activiy of Children</h4>
          <div className={styles.actionsContainer}>
            {quickActivityActions.map((action, index) => (
              <QuickActionCard
                backgroundColor={'rgba(from var(--Utility_Color1) r g b / 1)'}
                key={index}
                NoBgIcon={action.icon}
                label={action.label}
                onclick={action.onClick}
              />
            ))}
          </div>
        </div>
        <div className={styles.activitiesCotainer}>
          <div className={styles.wrapper}>
            <div className={styles.container}>
              <div className={styles.toolbarWrapper}>
                <div style={{ width: '320px' }}>
                  <SearchBar />
                </div>
                <div className={styles.toolbarOptions}>
                  <Dropdown
                    label="Room"
                    options={['Room A', 'Room B']}
                    onChange={(val) => handleFilterChange('room', val)}
                  />
                  <Dropdown
                    label="Program"
                    options={['KG', 'Grade 1']}
                    onChange={(val) => handleFilterChange('program', val)}
                  />
                  <Dropdown
                    label="Label"
                    options={['General', 'Urgent']}
                    onChange={(val) => handleFilterChange('label', val)}
                  />
                  <button
                    className={styles.archiveBtn}
                    onClick={() => {
                      console.log('Button Clicked');
                    }}
                  >
                    Unapproved
                  </button>
                  <button
                    className={styles.archiveBtn}
                    onClick={() => {
                      console.log('Button Clicked');
                    }}
                  >
                    Staff Only
                  </button>
                  <button
                    className={styles.archiveBtn}
                    onClick={() => {
                      console.log('Button Clicked');
                    }}
                  >
                    With Attachments
                  </button>
                </div>
              </div>

              <div className={styles.settingLinkContainer}>
                <NavLink to="/communication/activities/settings">
                  Settings
                </NavLink>
              </div>

              <div className={styles.pageWrapper}>
                <div className={styles.grid}>
                  {ActivitiesPages.map((item) => (
                    <ActivitiesPagesCard
                      key={item.id}
                      id={item.id}
                      image={item.image}
                      description={item.description}
                      tagged={item.tagged}
                      time={item.time}
                      date={item.date}
                      onActionSelect={handleActionSelect}
                      onRemoveTagged={handleRemoveTagged}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default ActivitiesPage;
